/**
* Segment analytics tracking.
*/

import { assign } from 'lodash';

export function trackEvent(event, params={}) {
    let globalTrackingParams = global.trackParams || {};
    params = assign(params, globalTrackingParams);

    if (!__DEV__) {
        if (window.analytics) {
            window.analytics.track(event, params);
        }
    } else {
        console.info('Track event "%s": %o', event, params);
    }
}

export function trackLinkClick(link, event, params={}) {
    let globalTrackingParams = global.trackParams || {};
    params = assign(params, globalTrackingParams);

    if (!__DEV__) {
        if (window.analytics) {
            window.analytics.trackLink(link, event, params);
        }
    } else {
        link.addEventListener('click', () => {
            console.info('Track event "%s": %o for %o', event, params, link);
        });
    }
}



/** WEBPACK FOOTER **
 ** ./js/common/utils/analytics.js
 **/